<template>
    <div class="col-md-6 col-lg-4 my-4" :key="index">
        <div class="card card-h100" v-data-href>

            <div class="card-body card-body-news">
                <p class="meta">
                    <span>{{ item.datum }}</span>
                </p>
                <h3 class="mb-3">{{ item.title }}</h3>
                <p>{{ item.intro }}</p>
                <a :href="item.url" class="btn btn-link mt-4">Lees verder</a>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            index: Number,
            item: Object,
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/components/Bericht.vue